<script setup lang="ts">
    import { useShippingStore } from '@/stores/shippingStore';
    import PackageProperties from './PackageProperties.vue';
    import RunImportSection from './RunImportSection.vue';
    import InspectExportOptionsButton from './InspectExportOptionsButton.vue';
    import EditPackageButton from './EditPackageButton.vue';
    import DeletePackageButton from './DeletePackageButton.vue';
    import DownloadPackageSection from './DownloadPackageSection.vue';
    import ReExportSection from './ReExportSection.vue';
    import PackageLog from './PackageLog.vue';
    import PackageChanges from './PackageChanges.vue';
    import PackageName from './PackageName.vue';

    const store = useShippingStore();
</script>

<template>
    <template
        v-if="store.selectedPackage">
        <div class="columns">
            <div class="column">
                <h2 class="title is-4">
                    <package-name />
                </h2>
            </div>
            <div class="column buttons is-flex is-justify-content-end is-align-items-end">
                <b-button
                    icon-left="close"
                    @click="store.clearSelectedPackage">
                    Close
                </b-button>
                <b-button
                    icon-left="refresh"
                    @click="store.refresh">
                    Refresh
                </b-button>
                <inspect-export-options-button />
                <edit-package-button />
                <delete-package-button />
            </div>
        </div>

        <div class="columns">
            <div class="column is-one-third">
                <package-properties />
            </div>
            <div class="column">
                <b-progress
                    v-show="store.showProgress"
                    size="is-small" />
                <download-package-section />
                <re-export-section />
                <run-import-section />
                <package-changes />
                <package-log />
            </div>
        </div>
    </template>
</template>

<style>
.shipping-section-header {
    color: #888888;
    border-bottom: solid 1px #444444;
    font-weight: 400;
}
</style>
